import { useTranslation } from "react-i18next"
import { Text, Toast, useToast } from "@oysterhr/ui"
import { NavigationButtons } from "~/shared/components/NavigationButtons"
import { PaymentMethodStripeAch } from "@oysterhr/schema"
import { useNavigate } from "react-router-dom"
import { useAccountAspect } from "@oysterhr/identity"
import { useAuthorizePaymentMethod } from "../../../../../hooks/useAuthorizeDirectDebitOnPaymentMethod"
import { companyPaymentMethodsPath } from "../../../../../../../utils/routeHelpers"

interface AuthorizationStepProps {
  paymentMethod: PaymentMethodStripeAch
}

export const AuthorizationStep = ({ paymentMethod }: AuthorizationStepProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/AchBankDetailsFlow")
  const toast = useToast()
  const navigate = useNavigate()
  const { accountAspect: companyId } = useAccountAspect()

  const [authorize, { loading: authorizing }] = useAuthorizePaymentMethod()

  const onAuthorize = () => {
    authorize({
      variables: {
        authorized: true,
        paymentMethodId: paymentMethod.id,
      },
      onCompleted: data => {
        if (data.authorizeDirectDebitOnPaymentMethod.errors.length) {
          toast({
            render: (
              <Toast variation="error">
                <Toast.Content>
                  {data?.authorizeDirectDebitOnPaymentMethod?.errors.join(", ")}
                </Toast.Content>
              </Toast>
            ),
          })
        } else {
          toast({
            render: (
              <Toast variation="success">
                <Toast.Title>{t("toasts.connected.title")}</Toast.Title>
                <Toast.Content>{t("toasts.connected.description")}</Toast.Content>
              </Toast>
            ),
          })
          navigate(companyPaymentMethodsPath(companyId))
        }
      },
    })
  }

  const { routingNumber, accountNumber, accountHolderName } = paymentMethod

  return (
    <div className="mt-8">
      <Text>{t("authorization.title")}</Text>
      <Text className="mt-4">{t("authorization.subtitle")}</Text>

      <Text className="mt-4 font-semibold">{t("accountHolderName")}</Text>
      <Text>{accountHolderName}</Text>

      <Text className="mt-4 font-semibold">{t("routingNumber")}</Text>
      <Text>{routingNumber}</Text>

      <Text className="mt-4 font-semibold">{t("accountNumber")}</Text>
      <Text>{accountNumber}</Text>

      <NavigationButtons
        loading={authorizing}
        onNext={onAuthorize}
        isFirst // Do not show back button
        isLast
        analyticsBase="ach-authorize-step"
        buttonText={t("authorization.submitButton")}
      />
    </div>
  )
}
